import React from 'react';
import { CheckCircle2, ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { PORTFOLIO_HIGHLIGHTS, BENEFITS, BenefitWithKey, PortfolioHighlightWithKey, CONTACT_INFO } from '../../constants/data';

export const ExperienceSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="experiencia" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
              {t('experience.title')} <br />
              <span className="text-blue-600">{t('experience.title_highlight')}</span>
            </h2>
            <div className="space-y-6">
              <p className="text-lg text-slate-600 leading-relaxed">
                {t('experience.description')}
              </p>

              <div className="space-y-4 pt-4">
                {BENEFITS.map((benefit, index) => (
                  <div key={index} className="flex gap-4 items-start">
                    <CheckCircle2 className="text-green-500 shrink-0 mt-1" />
                    <div>
                      <h4 className="font-bold text-slate-900">{t((benefit as BenefitWithKey).i18nTitle)}</h4>
                      <p className="text-slate-600 text-sm">{t((benefit as BenefitWithKey).i18nDesc)}</p>
                    </div>
                  </div>
                ))}
              </div>

              <a
                href={CONTACT_INFO.portfolioUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-semibold pt-2"
              >
                {t('experience.resume')}
                <ExternalLink size={16} />
              </a>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {PORTFOLIO_HIGHLIGHTS.map((item, index) => (
              <div
                key={index}
                className="bg-slate-50 p-6 rounded-2xl border border-slate-100 hover:bg-blue-50 transition-colors group"
              >
                <div className={`w-2 h-2 rounded-full ${item.color} mb-4`}></div>
                <h4 className="font-bold text-slate-900 text-lg mb-1 group-hover:text-blue-700 transition-colors">
                  {item.company}
                </h4>
                <span className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-1 block">
                  {t((item as PortfolioHighlightWithKey).i18nRole)}
                </span>
                <span className="text-xs text-slate-500 mb-3 block font-medium">
                  {t((item as PortfolioHighlightWithKey).i18nDate)}
                </span>
                <p className="text-sm text-slate-600">
                  {t((item as PortfolioHighlightWithKey).i18nDesc)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

